import { createFileRoute } from '@tanstack/react-router'

import {
  NewCaseDialog,
  ScreenerDashboard,
  useFetchFilings,
} from '@/modules/tools/bankruptcy'

export const Route = createFileRoute(
  '/_authenticated/tools/bankruptcy-screener/',
)({
  staticData: { title: 'Bankruptcy Screener' },
  component: ScreenerPage,
})

function ScreenerPage() {
  useFetchFilings()

  return (
    <>
      <ScreenerDashboard />
      <NewCaseDialog />
    </>
  )
}
